"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_VALUE = exports.TYPE = void 0;
const rich_text_1 = require("@vedalib/rich-text");
const translation_1 = require("../../../translation");
const id_1 = require("../../../utils/id");
const constants_1 = require("../../constants");
const types_1 = require("../../types");
const constants_2 = require("../../constants");
exports.TYPE = 'testGrouping';
exports.DEFAULT_VALUE = {
    items: [
        {
            value: (0, id_1.generateId)(),
            target: {
                label: (0, rich_text_1.textToRtValue)((0, translation_1.t)('elements.grouping.group', { number: 1 })),
                image: constants_1.imageValueWithObjectFit,
                overlay: null,
            },
        },
    ],
    answerFeedback: true,
    displayFeedback: true,
    displayOption: types_1.TestAnswerFeedbackDisplayOption.general,
    generalFeedback: constants_2.feedbackValue,
    generalTypeFb: types_1.TestAnswerFeedbackType.validation,
    showResult: true,
};
